import {useEffect} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../selectors/modules/lucky_wheel';
import {getWheelState, toggleWheel} from '../../../reducers/lucky-wheel/actions';
import {Overlay} from '../index';

import Rewards from './rewards';
import Spinner from './spinner';
import Lights from './lights';
import Won from './won';
import Widget from './widget';

export default () => {
    const {loaded, opened} = useSelector(Selector),
          dispatch = useDispatch();

    useEffect(() => {
        if(!loaded)
            dispatch(getWheelState());
    }, [loaded]);

    if(!loaded)
        return <></>;

    return (
        <AnimatePresence mode="wait">
            <Widget />

            {opened && (
                <Overlay className="wheel-overlay">
                    <div className="wheel-scale">
                        <motion.div
                            className="lucky-wheel"
                            initial={{
                                opacity: 0,
                                y: 20
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                                transition: {
                                    duration: 0.22,
                                    delay: 0.08, // сначала появляется overlay
                                    ease: [0.22, 1, 0.36, 1]
                                }
                            }}
                            exit={{
                                opacity: 0,
                                y: 20,
                                transition: {
                                    duration: 0.18,
                                    ease: "easeIn"
                                }
                            }}
                        >
                            <Won />
                            <div className="lucky-wheel-header">
                                <div className="background">
                                    <div className="confetti"></div>
                                </div>
                                <div className="content">
                                    <div className="close-button-container">
                                        <div className="close-button" onClick={e => {
                                            dispatch(toggleWheel());
                                        }}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>

                                    <motion.div
                                        className="logotype"
                                        animate={{
                                            filter: [
                                                'drop-shadow(0 0 0px rgba(255, 80, 210, 0))',
                                                'drop-shadow(0 0 8px rgba(255, 80, 210, 0.45))',
                                                'drop-shadow(0 0 14px rgba(255, 170, 40, 0.35))',
                                                'drop-shadow(0 0 0px rgba(255, 80, 210, 0))',
                                            ],
                                            // scale: [1, 1.015, 1],
                                        }}
                                        transition={{
                                            duration: 2.8,
                                            repeat: Infinity,
                                            repeatDelay: 1.5,
                                            ease: 'easeInOut',
                                        }}
                                    />
                                    <div className="text">Spin the wheel and<br />claim your lucky reward</div>
                                </div>
                            </div>

                            <div className="lucky-wheel-wheel">
                                <div className="wheel-selector">
                                    <div className="selector"></div>
                                </div>
                                <div className="wheel-mask">
                                    <Lights />
                                    <div className="semi-wheel"></div>
                                </div>
                                <div className="wheel-selector-shadow">
                                    <div className="selector-shadow"></div>
                                </div>
                                <Spinner />
                            </div>

                            <Rewards />
                        </motion.div>
                    </div>
                </Overlay>
            )}
        </AnimatePresence>
    )
}